import Swiper from 'swiper'
import SwiperModule from '../lib/swiper-module'

class MiniProductCarousel extends SwiperModule {
  initSwiper() {
    const fullWidth = this.getAttribute('data-full-width') === 'true'

    const swiper = new Swiper(this, {
      modules: this.swiperModules,
      slidesPerView: `auto`,
      scrollbar: {
        el: `#${this.id} .swiper-scrollbar`,
        hide: false,
      },
      slidesOffsetAfter: fullWidth ? 0 : 12,
      slidesOffsetBefore: fullWidth ? 0 : 12,
      navigation: {
        nextEl: `#${this.id} .custom-swiper-button-next`,
        prevEl: `#${this.id} .custom-swiper-button-prev`,
      },
      spaceBetween: fullWidth ? 0 : 12,
      breakpoints: {
        1024: {
          slidesPerView: `auto`,
          slidesOffsetAfter: fullWidth ? 0 : 24,
          slidesOffsetBefore: fullWidth ? 0 : 24,
          spaceBetween: fullWidth ? 0 : 24,
        },
      },
    })

    this.swiper = swiper
    window[`swiper_${this.id}`] = swiper
    this.setupAccessibility(swiper)
  }

  onOptionsClick(event) {
    event.preventDefault()
    event.target.parentElement.classList.add('active')
  }

  connectedCallback() {
    super.connectedCallback()
    // get all data-trigger-options
    const triggerOptions = this.querySelectorAll('[data-trigger-options]')
    // add event listener to each trigger option
    triggerOptions.forEach((triggerOption) => {
      triggerOption.addEventListener('click', this.onOptionsClick)
    })
  }

  disconnectedCallback() {
    // super.disconnectedCallback()
    // get all data-trigger-options
    const triggerOptions = this.querySelectorAll('[data-trigger-options]')
    // remove event listener to each trigger option
    triggerOptions.forEach((triggerOption) => {
      triggerOption.removeEventListener('click', this.onOptionsClick)
    })
  }
}

window.customElements.define('mini-product-carousel', MiniProductCarousel)
